// extracted by mini-css-extract-plugin
module.exports = {"inlineCode":"InlineCode_inlineCode__ATlYG"};